var map = {
	"./abc.jpg": "b9a3",
	"./bob.jpg": "842a",
	"./boc.jpg": "c4aa",
	"./bocom.jpg": "a1cc",
	"./cbhb.jpg": "3a1a",
	"./ccb.jpg": "8736",
	"./ceb.jpg": "dc12",
	"./cib.jpg": "cd43",
	"./citic.jpg": "fb1e",
	"./cmb.jpg": "50e9",
	"./cmbc.jpg": "7058",
	"./czb.jpg": "bd0c",
	"./gdb.jpg": "cdc1",
	"./hxb.jpg": "f1b1",
	"./hzb.jpg": "f482",
	"./icbc.jpg": "7a59",
	"./jsb.jpg": "c796",
	"./nbcb.jpg": "964e",
	"./pab.jpg": "31b4",
	"./psbc.jpg": "f6f7",
	"./shb.jpg": "83e1",
	"./spdb.jpg": "b37e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8979";